import { useEffect, useRef } from "react";

// Guards async continuations (navigate/dispatch after an awaited API call)
// against firing once the component that started them is no longer mounted —
// e.g. the user navigated away before a slow request resolved.
const useIsMounted = () => {
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return isMountedRef;
};

export default useIsMounted;
